/*constant variables for search configuration files */
export const SEARCH_CONFIG_PATENT = 'fs/res/searchPatent.xml';
export const SEARCH_CONFIG_PATENT_HEADLESS = 'fs/res/searchPatentHeadless.xml';

export const SEARCH_CONFIG_PROJECT = 'fs/res/searchProject.xml';
export const SEARCH_CONFIG_PROJECT_FOR_BUDGET_SOURCE = 'fs/res/searchProjectForBudgetSource.xml';
export const SEARCH_CONFIG_MINI_PROJECT = 'fs/res/searchMiniProject.xml';
export const SEARCH_CONFIG_PROJECT_HEADLESS = 'fs/res/searchProjectHeadless.xml';

export const SEARCH_CONFIG_BUDGET_SOURCE = 'fs/res/searchBudgetSource.xml';
export const SEARCH_CONFIG_BUDGET_SOURCE_BY_PARENT = 'fs/res/searchBudgetSourceByParent.xml';

export const SEARCH_CONFIG_PUBLICATION = 'fs/res/searchPublication.xml';
export const SEARCH_CONFIG_MINI_PUBLICATION = 'fs/res/searchMiniPublication.xml';
export const SEARCH_CONFIG_PUBLICATION_HEADLESS = 'fs/res/searchPublicationHeadless.xml';

export const SEARCH_CONFIG_JOURNAL = 'fs/res/searchJournal.xml';
export const SEARCH_CONFIG_MINI_JOURNAL = 'fs/res/searchMiniJournal.xml';

export const SEARCH_CONFIG_CONFERENCE = 'fs/res/searchConference.xml';
export const SEARCH_CONFIG_CONFERENCE_REDUCED = 'fs/res/searchConferenceReduced.xml';

export const SEARCH_CONFIG_PUBLISHER = 'fs/res/searchPublisher.xml';

export const SEARCH_CONFIG_EMPLOYMENT = 'cs/psv/searchEmploymentMinimal.xml';

export const SEARCH_CONFIG_FUNDING_NOTIFICATION = 'fs/res/searchFundingNotification.xml';
export const SEARCH_CONFIG_FUNDING_NOTIFICATION_FOR_BUDGETSOURCE = 'fs/res/searchFundingNotificationForBudgetSource.xml';
export const SEARCH_CONFIG_FUNDING_NOTIFICATION_UNCHECKED = 'fs/res/searchFundingNotificationUnchecked.xml';

export const SEARCH_CONFIG_PRIZE = 'fs/res/searchPrize.xml';
export const SEARCH_CONFIG_NOMINATION = 'fs/res/searchNomination.xml';
export const SEARCH_CONFIG_MINI_NOMINATION = 'fs/res/searchNomination.xml';

export const SEARCH_CONFIG_PUBLICATION_ORCID_USER = 'fs/res/searchPublicationOrcidUser.xml';

export const SEARCH_CONFIG_INFRASTRUCTURE = 'fs/res/searchResearchInfrastructure.xml';
